import { createSlice } from "@reduxjs/toolkit";
import { sliceNames } from "../helpers/constants";

const globalSliceReducerInitialState = {
    error: null,
    redirectPath: "/orders",
};

const globalSlice = createSlice({
    name: sliceNames.GLOBAL,
    initialState: globalSliceReducerInitialState,
    reducers: {
        setGlobalError(state, action) {
            state.error = action.payload;
        },
        clearGlobalError(state) {
            state.error = null;
        },
        setRedirectPath: (state, action) => {
            state.redirectPath = action.payload;
        },
        clearRedirectPath: (state) => {
            state.redirectPath = "/orders";
        },
    },
});

export const {
    setGlobalError,
    clearGlobalError,
    setRedirectPath,
    clearRedirectPath,
} = globalSlice.actions;

export default globalSlice.reducer;